import React, { FC } from 'react';
import { Hyperlink } from '../../../../../components/Hyperlink';
import styles from './animated_link.module.scss';
import { MaterialIcon } from '../../../../../components/material-icon/MaterialIcon';

type Props = React.HTMLProps<HTMLAnchorElement>;

export const SearchAnimatedLink: FC<Props> = ({ children, ...rest }) => (
  <Hyperlink className={styles.link} {...rest}>
    <span className={styles.label}>{children}</span>
    <MaterialIcon name="arrow_forward" className={styles.icon} />
  </Hyperlink>
);
